"use client";

import React from "react";
import { Hexagon } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = ["Manual spinal decompression for immediate nerve pressure relief", "Myofascial release targeting deep-seated muscle tension", "Evidence-based functional movement screening and correction", "Neuromuscular re-education for sustainable, lasting results"];
export default function LaminateDetails() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="149879" id="how-we-treat" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          {/* Text Content */}
          <div ref={textRef} className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-6 tracking-tight">
              Personalized Clinical Excellence
            </h2>
            <p className="text-secondary text-lg leading-[1.6] mb-8 font-sans">
              Our approach to recovery is built on the principle of fluid stability—balancing immediate relief with long-term structural integrity. We utilize precision manual techniques and advanced biomechanical analysis to restore your body's natural alignment and movement patterns.
            </p>
            
            <ul className="space-y-4">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <Hexagon className="w-5 h-5 text-accent shrink-0 mt-1" strokeWidth={1.5} aria-hidden="true" />
                  <span className="text-foreground font-sans leading-[1.6]">{feature}</span>
                </li>)}
            </ul>
          </div>

          {/* Image Content */}
          <div ref={imageRef} className={`lg:col-span-7 mt-10 lg:mt-0 transition-all duration-1000 delay-150 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="relative w-full aspect-[4/3] md:aspect-[16/10] rounded-2xl overflow-hidden shadow-xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/manual_therapy_care.png" alt="Close-up of a professional manual therapy session showing gentle adjustment and hands-on care" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}